import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import ObjetoPostalService from '../../services/ObjetoPostal';
import { errors } from '../../services/API';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';
import Table from '../../components/Table/Table';
import Toast from '../../components/Toast/Toast';

import { ButtonExport } from '../../forms/Buttons/ButtonsExport';

import { download } from '../../helper/FileHelper';

import AuthorizedElement from '../../security/AuthorizedElement';
import { 
  __OBJETO_POSTAL_POR_STATUS_EXPORTAR, 
  __OBJETO_POSTAL_EXPORTAR 
} from '../../security/RoleConfiguration';
import AuthorizedFunction from '../../security/AuthorizedFunction';

import { Layout } from '../../layouts/private/Private';

export class ObjetoPostalPorStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: [],
      loading: true,
    }
  }

  // FECHAR TOAST
  setToast = t => this.Toast = t;

  // EXPORTAÇÂO
  handleExportPlan = () => {
    this.Toast.setState({
      message: {
        message: "A Planilha está sendo gerada para Exportação.",
        type: 'info',
        open: true,
        loading: true, 
        autohide: false,
      }
    })

    ObjetoPostalService.porStatusExport([{ field: 'exportarPlanilha', value: true }])
      .then(res => download(res))
  }

  labelVerObjetosPostais = id => !this.disabledVerObjetosPostais(id) ? "Visualizar Objetos Postais" : "Você não tem permissão para fazer isso";
  disabledVerObjetosPostais = id => !AuthorizedFunction([__OBJETO_POSTAL_EXPORTAR]);
  handleVerObjetosPostais = id => this.props.history.push(`/admin/objetosPostais?status=${id}`);

  loadData = () => {
    this.setState({ loading: true, });

    ObjetoPostalService.porStatus([])
      .then(res => {
        this.setState({ status: [...res.data], loading: false, });
      })
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })

        this.setState({ loading: false });
      })
  }

  // COMPONENT DID MOUNT
  componentDidMount() { this.loadData(); }

  render() {
    const pageName = 'Objetos Postais Por Status';
    const links = [];

    const columns = [
      { label: '#', name: 'id', func: null, key: true },
      { label: 'Status', name: 'status', func: null, key: false },
      { label: 'Escolas', name: 'escolas', func: null, key: false },
      { label: 'Objetos Postais', name: 'objetosPostais', func: null, key: false },
    ];

    const actions = [
      {
        name: this.labelVerObjetosPostais,
        func: this.handleVerObjetosPostais,
        icon: <OpenInNewIcon />,
        disabled: this.disabledVerObjetosPostais,
      },
    ];

    return (
      <Layout>
        <Toast parentRef={this.setToast} />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Breadcrumbs links={links} active={pageName} />
          </Grid>
        </Grid>
        <Title>{pageName}</Title>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <AuthorizedElement roles={[__OBJETO_POSTAL_POR_STATUS_EXPORTAR]}>
                <ButtonExport
                  title="Exportar Planilha"
                  onClick={this.handleExportPlan}
                />
              </AuthorizedElement>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Table
              columns={columns}
              tableData={this.state.status}
              actions={actions}
              page={null}
              sort={null}
              rowsPerPage={null}
              loading={this.state.loading}
            />
          </Grid>
        </Grid>
      </Layout>
    )
  }
}

export default withRouter(ObjetoPostalPorStatus);